export const PROJECT_STATUS = {
  NOT_STARTED: 'Not Started',
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  CANCELLED: 'Cancelled',
  ON_HOLD: 'On Hold',
  COMPLETED: 'Completed',
};

export const PROJECT_VIEW_KEYS = {
  NOT_STARTED: 'not_started',
  ASSIGNED: 'assigned',
  IN_PROGRESS: 'in_progress',
  CANCELLED: 'cancelled',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed',
};

export const PROJECT_VIEW_MAP = {
  [PROJECT_STATUS.NOT_STARTED]: PROJECT_VIEW_KEYS.NOT_STARTED,
  [PROJECT_STATUS.ASSIGNED]: PROJECT_VIEW_KEYS.ASSIGNED,
  [PROJECT_STATUS.IN_PROGRESS]: PROJECT_VIEW_KEYS.IN_PROGRESS,
  [PROJECT_STATUS.CANCELLED]: PROJECT_VIEW_KEYS.CANCELLED,
  [PROJECT_STATUS.ON_HOLD]: PROJECT_VIEW_KEYS.ON_HOLD,
  [PROJECT_STATUS.COMPLETED]: PROJECT_VIEW_KEYS.COMPLETED,
};

export const PROJECT_STATUS_MAP = {
  [PROJECT_VIEW_KEYS.NOT_STARTED]: PROJECT_STATUS.NOT_STARTED,
  [PROJECT_VIEW_KEYS.ASSIGNED]: PROJECT_STATUS.ASSIGNED,
  [PROJECT_VIEW_KEYS.IN_PROGRESS]: PROJECT_STATUS.IN_PROGRESS,
  [PROJECT_VIEW_KEYS.CANCELLED]: PROJECT_STATUS.CANCELLED,
  [PROJECT_VIEW_KEYS.ON_HOLD]: PROJECT_STATUS.ON_HOLD,
  [PROJECT_VIEW_KEYS.COMPLETED]: PROJECT_STATUS.COMPLETED,
};

export const MILESTONE_STATUS = {
  NOT_STARTED: 'not_started',
  MILESTONE_ACHIEVED: 'milestone_achieved',
  PAYMENT_REQUESTED: 'payment_requested',
  PROFORMA_SENT: 'proforma_sent',
  AMOUNT_CREDITED: 'amount_credited',
  INVOICE_SENT: 'invoice_sent',
};
